import { render, staticRenderFns } from "./PlayerStrengthAndAgeTableCell.vue?vue&type=template&id=c2037212&"
import script from "./PlayerStrengthAndAgeTableCell.vue?vue&type=script&lang=js&"
export * from "./PlayerStrengthAndAgeTableCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports